import { memo } from 'react';

import { CheckIcon } from '@air/design-icons';

export const WorkspaceAgentGuidedVariantSizeSelectionMark = memo(() => (
  <CheckIcon aria-hidden className="size-4 shrink-0 ads:text-icon-primary text-blue-9" />
));

WorkspaceAgentGuidedVariantSizeSelectionMark.displayName = 'WorkspaceAgentGuidedVariantSizeSelectionMark';
